import type { Guest } from '@interfaces/guest.interface';

import { mockDb } from '../mock-db';

export function getGuestByIdMock(id: number): Guest | undefined {
  return mockDb.getGuestById(id);
}

export function getGuestsByBookingIdMock(bookingId: string): Guest[] {
  return mockDb.getGuestsByBookingId(bookingId);
}

export function createGuestMock(data?: Partial<Guest>): Guest {
  const base = mockDb.guests[0];
  return { ...base, id: Date.now(), ...data };
}

export function updateGuestMock(id: number, data: Partial<Guest>): Guest {
  const existing = mockDb.getGuestById(id);
  const base = existing ?? mockDb.guests[0];
  return { ...base, id, ...data };
}

export function updateGuestsByBookingMock(
  bookingId: string,
  payload: Guest[] | { guests?: Guest[] }
): void {
  const guests = Array.isArray(payload) ? payload : (payload.guests ?? []);
  mockDb.saveGuestsByBookingId(bookingId, guests);
}

export function deleteGuestMock(): { success: boolean } {
  return { success: true };
}

export function getAllGuestsMock(): Guest[] {
  return mockDb.getAllGuests();
}

export function submitCheckinMock(_bookingId: string): void {}
